import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Stop = (props) => (
  <Icon viewBox="0 0 14 14" {...props}>
    <g>
      <title>Terminate</title>
      <g fill="currentColor" fillRule="evenodd">
        <path d="M4.586 3.879l-.707.707 5.535 5.536.708-.707z" />
        <path d="M9.414 3.879L3.878 9.415l.708.707 5.535-5.536z" />
        <path d="M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m0 1c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Stop;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Stop.js